const BASE = process.env.REACT_APP_BACKEND_URL;

// Per-page SEO metadata. Masters can override any title/description via the
// Site Content panel (keys meta_<view>_title / meta_<view>_description).
export const PAGE_META = {
  landing: {
    path: "/",
    title: "NestTrack | Modern Childcare Management & Compliance SaaS Platform",
    description:
      "Empower your daycare, preschool, or childcare facility with NestTrack — ratios, staff time clock, parent messaging, billing and enrollment in one platform.",
  },
  about: {
    path: "/about",
    title: "About NestTrack | Childcare Management Built with Care",
    description: "Learn how NestTrack helps daycares, caregivers, and families connect through one calm, compliant platform.",
  },
  contact: {
    path: "/contact",
    title: "Contact NestTrack | We're Here to Help",
    description: "Questions about NestTrack childcare management? Reach our team for demos, support, and partnership inquiries.",
  },
  store: {
    path: "/store",
    title: "NestTrack Store | Daycare Supplies & Resources",
    description: "Shop curriculum kits, classroom supplies, and daycare essentials in the NestTrack store.",
  },
  providers: {
    path: "/providers",
    title: "State Provider Directory | NestTrack",
    description: "Browse caregiver and childcare assistance programs across all 50 states in the NestTrack provider directory.",
  },
  terms: {
    path: "/terms",
    title: "Terms of Service | NestTrack",
    description: "Read the NestTrack Terms of Service governing accounts, facilities, payments, and acceptable use.",
  },
  privacy: {
    path: "/privacy",
    title: "Privacy Policy | NestTrack",
    description: "How NestTrack collects, uses, and protects your family and facility data.",
  },
  care: {
    path: "/care",
    title: "Care Connections | Find Trusted Caregivers — NestTrack",
    description: "Discover vetted babysitters, nannies, and respite caregivers near you on NestTrack Care Connections.",
  },
  dashboard: {
    path: "/",
    title: "My Daycare Dashboard | NestTrack",
    description: "Manage enrollment, attendance, billing, staff, and parent communication from your NestTrack dashboard.",
  },
  master: {
    path: "/",
    title: "Master Control | NestTrack",
    description: "Platform-wide oversight and administration for NestTrack.",
  },
  "admin-inbox": {
    path: "/",
    title: "Secure Admin Inbox | NestTrack",
    description: "Confidential admin-to-admin messaging on NestTrack.",
  },
  "payment-success": {
    path: "/payment/success",
    title: "Order Confirmed | NestTrack Store",
    description: "Your NestTrack store order was completed successfully.",
  },
  "payment-cancel": {
    path: "/payment/cancel",
    title: "Checkout Cancelled | NestTrack Store",
    description: "Your NestTrack checkout was cancelled — no charge was made.",
  },
};

let metaOverrides = null;
async function loadOverrides() {
  try {
    const r = await fetch(`${BASE}/api/site-content`);
    if (r.ok) metaOverrides = (await r.json()).meta || {};
  } catch {
    /* keep stale overrides */
  }
}
if (typeof window !== "undefined") {
  loadOverrides();
  window.addEventListener("nt-content-changed", loadOverrides);
}

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export async function applyPageMeta(view) {
  const base = PAGE_META[view] || PAGE_META.landing;
  if (metaOverrides === null) await loadOverrides();
  const title = metaOverrides?.[`meta_${view}_title`] || base.title;
  const description = metaOverrides?.[`meta_${view}_description`] || base.description;
  const url = `${BASE}${base.path}`;
  document.title = title;
  upsertMeta("name", "title", title);
  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", url);
  upsertMeta("property", "twitter:title", title);
  upsertMeta("property", "twitter:description", description);
  upsertMeta("property", "twitter:url", url);
}
